const E = 6e5;
export {
  E as AUTH_TOKEN_EXPIRE_TIME
};
